module.exports = __webpack_public_path__ + "img/registeredpass.b14eacc8.svg";